import { SSOAuthorization, ENV } from "more-sso-sdk";
import { APP_ENV, DEV_USERNAME, REDIRECT_URL, APP_NAME, IDP_URL } from "../constants/constants";

export const initSSO = () => {
  console.log("initializing SSO");
  const isDev = process.env.REACT_APP_ENV === "DEV";

  SSOAuthorization.init({
    env: isDev ? ENV.DEV : ENV.PROD,
    redirectUrl: REDIRECT_URL,
    app: APP_NAME,
    idp: IDP_URL,
  });
};

export const getSSOToken = async () => {
  try {
    const isDev = APP_ENV === "DEV";

    if (isDev && DEV_USERNAME) {
      return await SSOAuthorization.getDevToken(DEV_USERNAME);
    }

    const encodedUrl = encodeURIComponent(window.location.href);
    return await SSOAuthorization.getToken(encodedUrl);
  } catch (err) {
    console.log("SSO Token fetch failed:", err);
    return null;
  }
};

export const logoutSSO = async () => {
  try {
    const redirectURL = encodeURIComponent(window.location.origin);
    await SSOAuthorization.logout(redirectURL);
  } catch (e) {
    console.log("SSO logout failed:", e);
  } finally {
    loginSSO();
  }
};

export const loginSSO = () => {
  const loginBase = REDIRECT_URL;

  const redirect = encodeURIComponent(window.location.origin);
  window.location.replace(`${loginBase}?redirect=${redirect}`);
};